import {
  ColumnFilter,
  DataTable,
  DataTableColumn,
  DataTableOptions,
  DataType,
  FilterType,
  SortDirection,
  UserPermission,
  useNotify
} from '@globaleris/ui.library'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { DataTableErrorHandler } from '../../../../components/errors/scopes/dataTable/dataTableError'

import {
  getActiveCommodities,
  getActiveCommodity,
  getCustomerDomain,
  storeActiveCommodity,
  storeCommodityFilterForCurrentPage,
  storeDataTableFilterForCurrentPage,
  storeDataTableRowsPerPageForCurrentPage,
  storeDataTableSearchForCurrentPage,
  storeShowOnlyActivesFilterForCurrentPage
} from '../../../../redux/helpers'

import { EnumCommodity, EnumTipoCalculoConcepto } from '../../../../api'
import { EnumClientTypes } from '../../../../api/Argentia/enums/enumClientTypes'
import { getUserPermissions } from '../../../../helpers/permissionsHelper'
import { useHttpError } from '../../../../hooks/useHttpError'
import { Pages } from '../../../../model/RBAC/constants'
import { RootStoreModel } from '../../../../redux'

import { useSelector } from 'react-redux'

import { FormControlLabel, Grid, Switch, Typography } from '@material-ui/core'
import { Block, CheckCircleOutline, Edit } from '@material-ui/icons'
import { useHistory } from 'react-router-dom'
import { EnumConceptType } from '../../../../api/Argentia/enums/enumConceptType'
import { ConceptModel } from '../../../../api/Argentia/model/contracts'
import CommodityFilter from '../../../../components/shared/commodityFilter/commodityFilter'
import { enumToSelectOptionArray, enumValueToKey } from '../../../../helpers'
import { useConfirmationDialog, usePageState } from '../../../../hooks'
import { NonAuthRoutes } from '../../../../model'
import { conceptsToConceptModelMapper } from '../../concepts.mapper'
import { fetchConcepts } from '../../concepts.service'

export interface ConceptsTableProps {
  clientType: EnumClientTypes
  onFetching?: (isFetching: boolean) => void
  dataTableRowsPerPage?: number
}

export const ConceptsTable: React.FC<ConceptsTableProps> = ({ clientType, ...props }) => {
  const [t] = useTranslation(['globalerisLibrary', 'enums', 'concepts'])
  const history = useHistory()

  const activeCompany = useSelector(
    (state: RootStoreModel) => state.profile?.activeCompany && state.profile?.activeCompany
  )
  const activeBalanceZone = useSelector(
    (state: RootStoreModel) => state.profile?.activeBalanceZone && state.profile?.activeBalanceZone
  )
  const {
    dataTableFilter,
    dataTableSearch,
    showOnlyActivesFilter,
    dataTableRowsPerPage,
    commodityFilter
  } = usePageState()
  const { getConfirmation, closeConfirmation } = useConfirmationDialog()

  const commodities = getActiveCommodities()
  const initialCommodityFilter: EnumCommodity =
    getActiveCommodity() ??
    (commodities !== undefined && commodities?.length > 0
      ? enumValueToKey(EnumCommodity, commodities[0])
      : EnumCommodity.GasNatural)

  const [showOnlyActives, setShowOnlyActives] = useState<boolean>(
    showOnlyActivesFilter === undefined ? true : showOnlyActivesFilter
  )
  const [commodity, setCommodity] = useState<EnumCommodity>(
    commodityFilter ?? initialCommodityFilter
  )
  const [concepts, setConcepts] = useState<ConceptModel[] | undefined>(undefined)
  const [isFetching, setIsFetching] = useState<boolean>(false)
  const { info, error } = useNotify()
  const { errorProps, showError } = useHttpError()

  //Enums Starts

  //Enums Ends

  //Form definition Starts

  //Form definitions ends

  // Handlers Starts
  // Handlers Ends

  // Functions Starts

  const onEditConceptHandler = (rowData: ConceptModel) => {
    history.push(NonAuthRoutes.ConceptsEdit, {
      clientType: clientType,
      calculationType: rowData.calculationType,
      conceptId: rowData.conceptId,
      commodity: commodity
    })
  }

  const onDisableConceptHandler = async (selectedRow: ConceptModel) => {
    // await getConfirmation(ConfirmationDialogs.PRODUCT_DISABLE).then(async () => {
    //   let newProductDetail: ProductDetail = mapProductDetail(selectedRow)
    //   newProductDetail.lgEnabled = false
    //   // call selected product info to ProductModel
    //   await updateProductDetail(newProductDetail).then(async response => {
    //     if (response.success) {
    //       info(t('products:table.rowCustomActions.disable.save.success'))
    //       // update table view after saving
    //       fetchProductsList({
    //         clientType,
    //         commodity,
    //         includeInactives: showOnlyActives ? false : true
    //       })
    //     } else {
    //       error(t('products:table.rowCustomActions.disable.save.error'))
    //     }
    //   })
    //   // close Confirmation
    //   closeConfirmation()
    // })
  }

  const onEnableProductHandler = async (selectedRow: ConceptModel) => {
    // await getConfirmation(ConfirmationDialogs.PRODUCT_ENABLE).then(async () => {
    //   let newProductDetail: ProductDetail = mapProductDetail(selectedRow)
    //   newProductDetail.lgEnabled = true
    //   // call selected product info to ProductModel
    //   await updateProductDetail(newProductDetail).then(async response => {
    //     if (response.success) {
    //       info(t('products:table.rowCustomActions.enable.save.success'))
    //       // update table view after saving
    //       fetchProductsList({
    //         clientType,
    //         commodity,
    //         includeInactives: showOnlyActives ? false : true
    //       })
    //     } else {
    //       error(t('products:table.rowCustomActions.enable.save.error'))
    //     }
    //   })
    //   // close Confirmation
    //   closeConfirmation()
    // })
  }

  const onSelectCommodityHandler = (commodity: EnumCommodity): void => {
    setCommodity(commodity)
    storeCommodityFilterForCurrentPage(commodity)
    storeActiveCommodity(commodity)
  }

  const renderCommodities = () => {
    if (commodities !== undefined && commodities.length > 1) {
      return (
        <CommodityFilter
          commodities={[
            { commodity: enumValueToKey(EnumCommodity, commodities[0]) },
            { commodity: enumValueToKey(EnumCommodity, commodities[1]) }
          ]}
          commodity={commodity}
          enabled={!isFetching}
          inactive={false}
          onSelectCommodity={onSelectCommodityHandler}
        />
      )
    }
    return
  }

  const onChangeIsActive = (event: any) => {
    setShowOnlyActives(!event.target.checked)
    fetchConceptTable({ clientType, commodity, includeInactives: event.target.checked })
    storeShowOnlyActivesFilterForCurrentPage(!event.target.checked)
  }

  const fetchConceptTable = async ({
    commodity,
    clientType,
    includeInactives,
    lgBypass
  }: {
    commodity: EnumCommodity
    clientType: EnumClientTypes
    includeInactives?: boolean | null
    lgBypass?: boolean | null
  }) => {
    setIsFetching(true)
    return await fetchConcepts({
      commodity,
      clientType,
      includeInactives: includeInactives,
      lgBypass: lgBypass
    })
      .then(response => {
        if (response.success && response.data) {
          setConcepts(conceptsToConceptModelMapper(response.data))
        } else {
          showError({ errorCode: response.error?.code, title: 'Error obteniendo productos' })
        }
      })
      .finally(() => {
        setIsFetching(false)
      })
  }

  // Functions Ends

  // DataTable Config Starts

  const columns = React.useMemo((): DataTableColumn[] => {
    return [
      {
        name: 'conceptId',
        display: false
      },
      // {
      //   name: 'actions',
      //   label: '',
      //   hideForResponsive: true,
      //   type: DataType.HTML
      // },
      {
        name: 'code',
        label: t('concepts:table.columns.code'),
        type: DataType.TEXT
      },
      {
        name: 'description',
        label: t('concepts:table.columns.description'),
        type: DataType.TEXT
      },
      {
        name: 'conceptType',
        label: t('concepts:table.columns.conceptType'),
        selectOptions: enumToSelectOptionArray(EnumConceptType, 'enums:EnumConceptType'),
        type: DataType.SELECT
      },
      {
        name: 'calculationType',
        label: t('concepts:table.columns.calculationType'),
        selectOptions: enumToSelectOptionArray(
          EnumTipoCalculoConcepto,
          'enums:EnumTipoCalculoConcepto'
        ),
        type: DataType.SELECT
      }
      // {
      //   name: 'quantityType',
      //   label: t('concepts:table.columns.quantityType'),
      //   type: DataType.TEXT
      // }
    ]
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientType, commodity, activeBalanceZone, activeCompany, showOnlyActives])

  const handleInsertAction = async () => {
    history.push(NonAuthRoutes.ConceptsAdd, { clientType: clientType })
    return true
  }

  const options = React.useMemo((): DataTableOptions => {
    return {
      i18n: t('globalerisLibrary:dataTable', { returnObjects: true }),
      search: true,
      elevation: 1,
      filterType: FilterType.ADVANCED,
      download: true,
      canEdit: false,
      canDelete: false,
      canInsert: true,
      customInsertEditModal: true,
      sortOrder: {
        name: 'conceptId',
        direction: SortDirection.DESC
      },
      pagination: true,
      rowsPerPage: dataTableRowsPerPage || 10,
      rowsPerPageOptions: [10, 20, 100],
      analytics: {
        customer: getCustomerDomain(),
        view: t('concepts:table.analytics')
      },
      onRowInsert: handleInsertAction,
      rowCustomActions: [
        {
          icon: <Edit fontSize="small" />,
          tooltip: t('concepts:table.tooltips.edit'),
          onClick: rowData => onEditConceptHandler(rowData),
          userPermission: UserPermission.EDIT
        },
        {
          icon: <Block fontSize="small" />,
          tooltip: t('concepts:table.tooltips.disable'),
          onClick: onDisableConceptHandler,
          userPermission: UserPermission.EDIT
          // visibleIf: 'showDisableIcon'
        },
        {
          icon: <CheckCircleOutline fontSize="small" />,
          tooltip: t('concepts:table.tooltips.enable'),
          onClick: onEnableProductHandler,
          userPermission: UserPermission.EDIT
          // visibleIf: 'showEnableIcon'
        }
      ],
      onFilterChange: (filter: ColumnFilter[]) => {
        storeDataTableFilterForCurrentPage(filter)
      },
      onSearchChange: (search: string) => {
        storeDataTableSearchForCurrentPage(search)
      },
      onRowsPerPageChange: (rowsPerPage: number) => {
        storeDataTableRowsPerPageForCurrentPage(rowsPerPage)
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }
  }, [
    clientType,
    commodity,
    activeBalanceZone,
    activeCompany,
    showOnlyActives,
    dataTableRowsPerPage
  ])

  // DataTable Config Ends

  // Hooks Starts

  useEffect(() => {
    fetchConceptTable({
      clientType,
      commodity,
      includeInactives: showOnlyActives ? false : true,
      lgBypass: null
    })

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeBalanceZone, commodity])

  // Hooks Ends

  return (
    <>
      <Grid container direction="column" spacing={2}>
        <Grid container item direction="row" style={{ marginLeft: 'auto', gap: '10px' }}>
          <Grid item style={{ marginRight: 'auto' }}>
            <FormControlLabel
              style={{ marginLeft: 8 }}
              control={
                <Switch
                  size="small"
                  checked={!showOnlyActives}
                  onChange={onChangeIsActive}
                  name="unsuscribed"
                  color="primary"
                  disabled={isFetching}
                  inputProps={{ 'aria-label': 'unsuscribed clients' }}
                />
              }
              label={
                <Typography variant="subtitle2" color="secondary">
                  {t('concepts:filters.showInactives')}
                </Typography>
              }
              disabled={isFetching}
            />
          </Grid>
          <Grid item style={{ marginLeft: 'auto' }}>
            {renderCommodities()}
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <DataTable
            data={concepts}
            columns={columns}
            options={options}
            info={DataTableErrorHandler(errorProps)}
            userPermissions={getUserPermissions(Pages.Client)}
            appliedFilter={dataTableFilter}
            appliedSearch={dataTableSearch}
          />
        </Grid>
      </Grid>
    </>
  )
}
